import type { NextPage } from 'next'

import { getStaticPropsWrapper } from '~/utils/pageWrapper/staticPageWrapper'

import { MarketingHomePage, getMarketingProps } from './index'

// Deliberately bypasses the school-edition gate on `/`: this is a b2c A/B route, so it stays on the
// marketing page in every edition.
const LandingControlPage: NextPage = () => {
  return <MarketingHomePage forcedVariant="control" />
}

export const getStaticProps = getStaticPropsWrapper(getMarketingProps)

export default LandingControlPage
